import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    padding: theme.spacing(4),
  },
  image: {
    marginTop: theme.spacing(10),
    display: 'inline-block',
    maxWidth: '100%',
    width: 300,
  },
  subtitle: {
    maxWidth: 500,
    marginTop: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(4),
  },
}))

export default useStyles
